<template>
  <div class="stores">
    <div class="item" v-for="item in pageData" :key="item.merchantId">
      <p class="name">{{item.merchantName}}</p>
      <p class="addr gray">{{item.address}} </p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      params: {
        campaignProductId: ''
      },
      pageData: []
    }
  },
  created () {
    let queryParams = this.$route.query
    this.params.campaignProductId = queryParams.campaignProductId
    // window.document.title = this.$i18n.t(this.$route.meta.title)
    this.loadData()
  },
  methods: {
    // 获取可用门店列表
    getLisMerchantByCampaignProductId (params) {
      return this.$http.post('/olvp/getLisMerchantByCampaignProductId', 'getLisMerchantByCampaignProductId', params, false, false)
    },
    loadData () {
      this.getLisMerchantByCampaignProductId(this.params).then((d) => {
        if (d.success) {
          this.pageData = d.content.dataList
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .stores {
    width: 100%;
    padding: 15px 20px;
    .item {
      border: 1px dashed #ccc;
      background: rgba(250,250,250,1);
      padding: 12px 15px;
      border-radius: 5px;
      margin-bottom: 10px;
      .name {
        font-size: 16px;
        margin-bottom: 5px;
      }
      .addr {
        font-size: 14px;
        line-height: 22px;
      }
    }
  }
</style>
